import styled from 'styled-components';

export default styled.span`
  font-family: ${({ theme }) => theme.fontFamily};
  text-transform: none;
  display: block;
`;
